// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UoMdT1jO8SmZe0pzyd5i {
	display: flex;
	flex-direction: column;
}

.XKrCqXcfsR542iPeK0kY {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
}

.bwmOpcdhFlskkj5hDfdq {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.06em;
	line-height: 28px;
	opacity: 0.5;
}

.ArvRf51urAWyjTmevk0O {
	align-items: center;
	background: var(--white);
	border-radius: 12px;
	display: flex;
	gap: 16px;
	height: 56px;
	padding: 0px 12px;
}

.mFcYo5AofkppQt2Obmpg {
	background-color: var(--white);
	border: none;
	color: var(--black);
	flex: 1;
	font-size: 16px;
	height: 100%;
	letter-spacing: -0.08em;
	line-height: 24px;
	min-width: 100px;
	outline: none;
}

.H7JxE0M1ncRkPATbG8Bc {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.06em;
	line-height: 28px;
	margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SymbiosisInput/SymbiosisInput.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,wBAAwB;CACxB,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;CAC9B,YAAY;CACZ,mBAAmB;CACnB,OAAO;CACP,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;AACjB","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.header {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 8px;\n}\n\n.label {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.06em;\n\tline-height: 28px;\n\topacity: 0.5;\n}\n\n.content {\n\talign-items: center;\n\tbackground: var(--white);\n\tborder-radius: 12px;\n\tdisplay: flex;\n\tgap: 16px;\n\theight: 56px;\n\tpadding: 0px 12px;\n}\n\n.input {\n\tbackground-color: var(--white);\n\tborder: none;\n\tcolor: var(--black);\n\tflex: 1;\n\tfont-size: 16px;\n\theight: 100%;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tmin-width: 100px;\n\toutline: none;\n}\n\n.helperText {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.06em;\n\tline-height: 28px;\n\tmargin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UoMdT1jO8SmZe0pzyd5i`,
	"header": `XKrCqXcfsR542iPeK0kY`,
	"label": `bwmOpcdhFlskkj5hDfdq`,
	"content": `ArvRf51urAWyjTmevk0O`,
	"input": `mFcYo5AofkppQt2Obmpg`,
	"helperText": `H7JxE0M1ncRkPATbG8Bc`
};
export default ___CSS_LOADER_EXPORT___;
